/* Calibre · thème Shopify Armurerie Défense. JavaScript sans dépendance, composants en custom elements. */
(() => {
  'use strict';

  const T = window.theme || { routes: {}, settings: {}, strings: {} };
  // Les traductions Liquid arrivent échappées (&#39;…) : on les décode une fois
  const decode = (s) => { const t = document.createElement('textarea'); t.innerHTML = String(s ?? ''); return t.value; };
  const decodeAll = (o) => Object.fromEntries(Object.entries(o || {}).map(([k, v]) => [k, decode(v)]));
  const S = decodeAll(T.strings);
  const ROOT = (T.routes.root || '/').replace(/\/$/, '');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ───────── Prix ───────── */
  function formatMoney(cents) {
    const fmt = String(T.settings.moneyFormat || '{{amount_with_comma_separator}} €').replace(/<[^>]*>/g, '');
    const v = Number(cents || 0) / 100;
    const fix = (d, ts, ds) => {
      const [i, f] = v.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return fix(0, ',', '.');
        case 'amount_with_comma_separator': return fix(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(0, '.', ',');
        case 'amount_with_space_separator': return fix(2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fix(2, ' ', '.');
        case 'amount_with_apostrophe_separator': return fix(2, "'", '.');
        default: return fix(2, ',', '.');
      }
    });
  }
  const formatJ = (j) => (Number(j) > 0 ? `${Number(j).toFixed(2).replace('.', ',')} J` : '');

  /* ───────── Stockage local (favoris, comparateur, vus récemment) ───────── */
  const store = {
    get(k, d) { try { const v = JSON.parse(localStorage.getItem(k)); return v ?? d; } catch { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* navigation privée */ } },
  };
  function makeList(key, max) {
    const emit = () => document.dispatchEvent(new CustomEvent('lists:change', { detail: { key } }));
    return {
      all: () => store.get(key, []),
      has: (h) => store.get(key, []).some((i) => i.handle === h),
      toggle(item) {
        const l = store.get(key, []);
        const i = l.findIndex((x) => x.handle === item.handle);
        if (i >= 0) { l.splice(i, 1); store.set(key, l); emit(); return false; }
        if (max && l.length >= max) return null;
        l.push(item); store.set(key, l); emit(); return true;
      },
      remove(h) { store.set(key, store.get(key, []).filter((i) => i.handle !== h)); emit(); },
      clear() { store.set(key, []); emit(); },
    };
  }
  const favs = makeList('calibre:favs');
  const compare = makeList('calibre:compare', 3);

  /* ───────── Notifications ───────── */
  function toast(message, link) {
    const box = $('.toaster');
    if (!box) return;
    const el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML = `<span>${esc(message)}</span>${link ? `<a href="${esc(link.href)}">${esc(link.label)}</a>` : ''}`;
    box.append(el);
    setTimeout(() => { el.classList.add('is-leaving'); setTimeout(() => el.remove(), 220); }, 3200);
  }

  /* ───────── Fenêtres (dialog natif) ───────── */
  const openDialog = (d) => { if (d && !d.open) d.showModal(); };
  const closeDialog = (d) => { if (d && d.open) d.close(); };
  function openSearch() {
    const d = $('#SearchDialog');
    openDialog(d);
    setTimeout(() => $('[data-search-input]', d)?.focus(), 60);
  }
  function openCart() {
    const d = $('#CartDrawer');
    if (T.settings.cartType === 'page' || !d) { window.location.href = T.routes.cart; return; }
    openDialog(d);
  }

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t instanceof HTMLDialogElement && !t.hasAttribute('data-locked')) { t.close(); return; }
    const opener = t.closest('[data-open-modal]');
    if (opener) { e.preventDefault(); openDialog(document.getElementById(opener.dataset.openModal)); return; }
    const closer = t.closest('[data-close]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    if (t.closest('[data-open-search]')) { e.preventDefault(); openSearch(); return; }
    if (t.closest('[data-open-menu]')) { openDialog($('#MobileMenu')); return; }
    if (t.closest('[data-open-cart]') && T.settings.cartType === 'drawer' && $('#CartDrawer')) { e.preventDefault(); openCart(); return; }
    const toggle = t.closest('[data-auth-toggle]');
    if (toggle) {
      e.preventDefault();
      $('[data-auth-login]')?.toggleAttribute('hidden');
      $('[data-auth-recover]')?.toggleAttribute('hidden');
    }
  });

  document.addEventListener('keydown', (e) => {
    const t = e.target;
    if (e.key === '/' && !/input|textarea|select/i.test(t.tagName) && !t.isContentEditable && !document.querySelector('dialog[open]')) {
      e.preventDefault();
      openSearch();
    }
  });

  /* ───────── Apparitions au défilement ───────── */
  const revealIO = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        for (const en of entries) {
          if (en.isIntersecting) { en.target.dataset.visible = 'true'; revealIO.unobserve(en.target); }
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;
  function initReveal(scope = document) {
    $$('[data-reveal]', scope).forEach((el) => {
      if (!revealIO || T.settings.designMode) el.dataset.visible = 'true';
      else revealIO.observe(el);
    });
  }

  /* ───────── Transition fluide carte → fiche produit ───────── */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.card__link, .pick, .ps__product');
    if (!link || !document.documentElement.classList.contains('vt')) return;
    $$('.gallery__img').forEach((i) => { i.style.viewTransitionName = 'none'; });
    $$('.card__img').forEach((i) => { i.style.viewTransitionName = ''; });
    const img = link.closest('.card')?.querySelector('.card__img');
    if (img) img.style.viewTransitionName = 'product-plate';
  }, true);
  window.addEventListener('pageshow', () => {
    $$('.card__img, .gallery__img').forEach((i) => { i.style.viewTransitionName = ''; });
  });

  /* ───────── En-tête : méga-menu et masquage au défilement ───────── */
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.buttons = $$('[data-mega]', this);
      this.panels = $$('[data-mega-panel]', this);
      this.current = null;
      this.timer = null;
      this.buttons.forEach((b) => {
        b.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.open(b.dataset.mega); });
        b.addEventListener('click', () => this.open(this.current === b.dataset.mega ? null : b.dataset.mega));
      });
      $$('.nav__link:not([data-mega])', this).forEach((a) => a.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.open(null); }));
      this.panels.forEach((p) => p.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') clearTimeout(this.timer); }));
      this.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.open(null), 140);
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.open(null); });

      if (this.dataset.hide === 'true') {
        let last = window.scrollY;
        let ticking = false;
        window.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const y = window.scrollY;
            if (Math.abs(y - last) > 6) {
              this.dataset.hidden = y > last && y > 160 && !this.current ? 'true' : 'false';
              last = y;
            }
            ticking = false;
          });
        }, { passive: true });
      }
    }
    open(id) {
      clearTimeout(this.timer);
      this.current = id;
      this.buttons.forEach((b) => b.setAttribute('aria-expanded', String(b.dataset.mega === id)));
      this.panels.forEach((p) => { p.dataset.open = String(p.dataset.megaPanel === id); });
    }
  }
  define('site-header', SiteHeader);
  define('mobile-menu', class extends HTMLElement {});

  /* ───────── Recherche instantanée ───────── */
  class SearchDialog extends HTMLElement {
    connectedCallback() {
      this.input = $('[data-search-input]', this);
      this.live = $('[data-search-live]', this);
      this.def = $('[data-search-default]', this);
      if (!this.input || !T.settings.predictiveSearch) return;
      this.input.addEventListener('input', debounce(() => this.search(), 220));
    }
    async search() {
      const q = this.input.value.trim();
      this.controller?.abort();
      if (q.length < 2) { this.live.innerHTML = ''; this.def.hidden = false; return; }
      this.controller = new AbortController();
      const params = new URLSearchParams({
        q,
        section_id: 'predictive-search',
        'resources[type]': 'product,collection,article,page,query',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
      });
      try {
        const res = await fetch(`${T.routes.predictiveSearch}?${params}`, { signal: this.controller.signal });
        if (!res.ok) return;
        const doc = parse(await res.text());
        const results = $('[data-ps-results]', doc);
        this.live.innerHTML = results ? results.outerHTML : '';
        this.def.hidden = !!results;
      } catch { /* requête annulée */ }
    }
  }
  define('search-dialog', SearchDialog);

  /* ───────── Panier (API AJAX + rendu des sections) ───────── */
  function cartSections() {
    const ids = ['cart-drawer'];
    const page = $('cart-page');
    if (page?.dataset.section) ids.push(page.dataset.section);
    return ids;
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = Number(n) === 0;
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }
  function renderSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const doc = parse(sections['cart-drawer']);
      const fresh = $('[data-drawer-body]', doc);
      const current = $('#CartDrawer [data-drawer-body]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const count = $('cart-drawer', doc)?.dataset.count;
      if (count != null) updateCount(count);
    }
    const page = $('cart-page');
    if (page && sections[page.dataset.section]) {
      const doc = parse(sections[page.dataset.section]);
      const fresh = $('[data-cart-body]', doc);
      const current = $('[data-cart-body]', page);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
  }
  async function cartRequest(path, body) {
    const res = await fetch(`${ROOT}/cart/${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: cartSections(), sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw data;
    renderSections(data.sections);
    return data;
  }

  // Quantités et suppression dans le panier latéral et la page panier
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const line = btn.closest('[data-line]');
    const list = btn.closest('[data-lines]');
    if (!line) return;
    list?.classList.add('is-busy');
    try {
      await cartRequest('change.js', { line: Number(line.dataset.line), quantity: Number(btn.dataset.qty) });
    } catch (err) {
      toast(err?.description || err?.message || S.addError);
      list?.classList.remove('is-busy');
    }
  });
  document.addEventListener('input', debounce((e) => {
    const note = e.target.closest?.('[data-cart-note]');
    if (!note) return;
    fetch(`${ROOT}/cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  }, 500));

  define('cart-drawer', class extends HTMLElement {});
  define('cart-page', class extends HTMLElement {});

  /* ───────── Ajout au panier (cartes et fiche produit) ───────── */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = $('form', this);
      if (!this.form) return;
      this.form.addEventListener('submit', (e) => this.submit(e));
    }
    async submit(e) {
      e.preventDefault();
      const form = this.form;
      if (!form.checkValidity()) { form.reportValidity(); return; }
      const button = e.submitter || $('[type="submit"]', form);
      button?.classList.add('is-loading');
      const fd = new FormData(form);
      const properties = {};
      for (const [k, v] of fd.entries()) {
        const m = k.match(/^properties\[(.+)\]$/);
        if (m && String(v).trim()) properties[m[1]] = v;
      }
      const items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1), properties }];
      // form.id renverrait le champ caché name="id" : on lit l'attribut
      const formId = form.getAttribute('id');
      const addons = formId ? $$(`[data-addon][form="${formId}"]:checked`) : [];
      addons.forEach((a) => items.push({ id: Number(a.value), quantity: 1 }));
      try {
        await cartRequest('add.js', { items });
        addons.forEach((a) => { a.checked = false; });
        document.dispatchEvent(new CustomEvent('cart:added'));
        if (T.settings.cartType === 'page') window.location.href = T.routes.cart;
        else openCart();
      } catch (err) {
        toast(err?.description || err?.message || S.addError);
      } finally {
        button?.classList.remove('is-loading');
      }
    }
  }
  define('product-form', ProductForm);

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = $('input', this);
      $$('[data-step]', this).forEach((b) => b.addEventListener('click', () => {
        const min = Number(this.input.min || 1);
        const max = Number(this.input.max || 99);
        const v = Math.min(max, Math.max(min, Number(this.input.value || 1) + Number(b.dataset.step)));
        this.input.value = v;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
    }
  }
  define('quantity-input', QuantityInput);

  /* ───────── Fiche produit ───────── */
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.formId = this.dataset.form;
      const json = this.closest('section')?.querySelector('[data-product-json]');
      try { this.product = JSON.parse(json?.textContent || 'null'); } catch { this.product = null; }

      this.addEventListener('change', (e) => {
        if (e.target.closest('variant-picker')) this.onVariantChange();
      });
      document.addEventListener('change', (e) => {
        if (e.target.matches?.(`[form="${this.formId}"], #${this.formId} input`)) this.updateTotal();
      });
      this.updateTotal();

      if (this.dataset.recent === 'true') {
        const h = this.dataset.handle;
        store.set('calibre:recent', [h, ...store.get('calibre:recent', []).filter((x) => x !== h)].slice(0, 12));
      }

      const scope = this.closest('section');
      if ($('[data-alert-success]', scope)) openDialog($('dialog[id^="StockAlert"]', scope));

      const buy = $('[data-buy]', this);
      const sticky = $('sticky-atc', scope);
      if (buy && sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => {
          const show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.dataset.visible = String(show);
          sticky.setAttribute('aria-hidden', String(!show));
          $$('button', sticky).forEach((b) => { b.tabIndex = show ? 0 : -1; });
        }).observe(buy);
      }
    }
    selectedOptions() {
      return $$('variant-picker fieldset', this).map((fs) => $('input:checked', fs)?.value);
    }
    async onVariantChange() {
      if (!this.product) return;
      const opts = this.selectedOptions();
      $$('variant-picker fieldset', this).forEach((fs, i) => { const s = $('[data-selected]', fs); if (s) s.textContent = opts[i] || ''; });
      const variant = this.product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      const input = $(`#${this.formId} [data-variant-input]`);
      const atc = $('[data-add]', this);
      if (!variant) {
        if (atc) { atc.disabled = true; atc.querySelector('span').textContent = S.unavailable; }
        return;
      }
      if (input) input.value = variant.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      if (variant.featured_media) $('product-gallery', this)?.goToMedia(variant.featured_media.id);

      const active = document.activeElement;
      const activeKey = active?.name ? `${active.name}|${active.value}` : null;
      try {
        const res = await fetch(`${this.dataset.url}?variant=${variant.id}&section_id=${this.section}`);
        const doc = parse(await res.text());
        const scope = this.closest('section');
        $$('[data-swap]', doc).forEach((fresh) => {
          const cur = $(`[data-swap="${fresh.dataset.swap}"]`, scope);
          if (cur) cur.innerHTML = fresh.innerHTML;
        });
        const body = $('[data-alert-body]', doc);
        if (body) $('[data-alert-body]', scope)?.setAttribute('value', body.getAttribute('value'));
        const variantLabel = $('[data-alert-variant]', doc);
        if (variantLabel) $('[data-alert-variant]', scope).textContent = variantLabel.textContent;
        if (activeKey) {
          const [name, value] = activeKey.split('|');
          $$(`input[name="${CSS.escape(name)}"]`, this).find((i) => i.value === value)?.focus();
        }
        this.updateTotal();
      } catch { /* garde l'affichage actuel */ }
    }
    updateTotal() {
      const atc = $('[data-add]', this);
      const total = $('[data-total]', this);
      if (!atc || !total) return;
      const qty = Number($(`#${this.formId} [name="quantity"]`)?.value || 1);
      const addons = $$(`[data-addon][form="${this.formId}"]:checked`).reduce((n, a) => n + Number(a.dataset.price || 0), 0);
      total.textContent = formatMoney(Number(atc.dataset.basePrice || 0) * qty + addons);
    }
  }
  define('product-info', ProductInfo);
  define('variant-picker', class extends HTMLElement {});
  define('sticky-atc', class extends HTMLElement {});
  define('modal-dialog', class extends HTMLElement {});

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.main = $('[data-main]', this);
      this.thumbs = $$('[data-thumb]', this);
      this.thumbs.forEach((b) => b.addEventListener('click', () => this.goTo(Number(b.dataset.thumb))));
      this.main?.addEventListener('scroll', debounce(() => {
        const i = Math.round(this.main.scrollLeft / this.main.clientWidth);
        this.thumbs.forEach((b, j) => b.setAttribute('aria-current', String(i === j)));
      }, 80), { passive: true });
      if (this.classList.contains('gallery--zoom')) {
        this.main?.addEventListener('pointermove', (e) => {
          const img = e.target.closest('.gallery__slide')?.querySelector('.gallery__img');
          if (!img) return;
          const r = img.getBoundingClientRect();
          img.style.setProperty('--zx', `${((e.clientX - r.left) / r.width) * 100}%`);
          img.style.setProperty('--zy', `${((e.clientY - r.top) / r.height) * 100}%`);
        });
      }
    }
    goTo(i) {
      this.main?.scrollTo({ left: i * this.main.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      this.thumbs.forEach((b, j) => b.setAttribute('aria-current', String(i === j)));
    }
    goToMedia(id) {
      const slides = $$('.gallery__slide', this.main);
      const i = slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (i >= 0) this.goTo(i);
    }
  }
  define('product-gallery', ProductGallery);

  class ShareButton extends HTMLElement {
    connectedCallback() {
      $('button', this)?.addEventListener('click', async () => {
        const data = { title: this.dataset.title, url: this.dataset.url };
        if (navigator.share) { try { await navigator.share(data); return; } catch { return; } }
        try { await navigator.clipboard.writeText(data.url); toast(S.copied); } catch { /* refusé */ }
      });
    }
  }
  define('share-button', ShareButton);

  /* ───────── Favoris et comparateur ───────── */
  class FavButton extends HTMLElement {
    connectedCallback() {
      this.btn = $('button', this);
      this.sync = () => this.btn?.setAttribute('aria-pressed', String(favs.has(this.dataset.handle)));
      this.sync();
      document.addEventListener('lists:change', this.sync);
      this.btn?.addEventListener('click', (e) => {
        e.preventDefault();
        const added = favs.toggle({ handle: this.dataset.handle, title: this.dataset.title });
        toast(added ? S.favAdded : S.favRemoved, added ? { href: `${T.routes.search}?view=favoris`, label: '→' } : null);
      });
    }
    disconnectedCallback() { document.removeEventListener('lists:change', this.sync); }
  }
  define('fav-button', FavButton);

  class CompareButton extends HTMLElement {
    connectedCallback() {
      this.btn = $('button', this);
      this.sync = () => this.btn?.setAttribute('aria-pressed', String(compare.has(this.dataset.handle)));
      this.sync();
      document.addEventListener('lists:change', this.sync);
      this.btn?.addEventListener('click', (e) => {
        e.preventDefault();
        const added = compare.toggle({ handle: this.dataset.handle, title: this.dataset.title, image: this.dataset.image });
        if (added === null) toast(S.compareFull);
      });
    }
    disconnectedCallback() { document.removeEventListener('lists:change', this.sync); }
  }
  define('compare-button', CompareButton);

  function syncFavDot() {
    $$('[data-fav-dot]').forEach((d) => { d.hidden = favs.all().length === 0; });
  }
  document.addEventListener('lists:change', syncFavDot);

  class CompareTray extends HTMLElement {
    connectedCallback() {
      this.list = $('[data-list]', this);
      this.render = this.render.bind(this);
      document.addEventListener('lists:change', this.render);
      $('[data-clear]', this)?.addEventListener('click', () => compare.clear());
      this.list.addEventListener('click', (e) => {
        const b = e.target.closest('[data-remove]');
        if (b) compare.remove(b.dataset.remove);
      });
      this.render();
    }
    render() {
      const items = compare.all();
      const onComparePage = !!$('compare-table');
      if (!items.length || onComparePage) {
        this.dataset.visible = 'false';
        setTimeout(() => { if (this.dataset.visible === 'false') this.hidden = true; }, 300);
        return;
      }
      this.hidden = false;
      this.list.innerHTML = items.map((i) => `<li><img src="${esc(i.image)}" alt="${esc(i.title)}" loading="lazy"><button type="button" data-remove="${esc(i.handle)}" aria-label="×">×</button></li>`).join('');
      $('[data-count]', this).textContent = items.length;
      $('[data-go]', this).href = `${this.dataset.url}&h=${items.map((i) => encodeURIComponent(i.handle)).join(',')}`;
      requestAnimationFrame(() => { this.dataset.visible = 'true'; });
    }
  }
  define('compare-tray', CompareTray);

  async function fetchCard(handle) {
    const res = await fetch(`${ROOT}/products/${encodeURIComponent(handle)}?view=card`);
    if (!res.ok) return null;
    const html = (await res.text()).trim();
    return html.startsWith('<article') ? html : null;
  }

  class FavoritesList extends HTMLElement {
    connectedCallback() { this.render(); }
    async render() {
      const list = $('[data-list]', this);
      const items = favs.all();
      $('[data-empty]', this).hidden = items.length > 0;
      const cards = await Promise.all(items.map((i) => fetchCard(i.handle).catch(() => null)));
      list.innerHTML = '';
      cards.forEach((html, k) => {
        if (!html) { favs.remove(items[k].handle); return; }
        const li = document.createElement('li');
        li.innerHTML = html;
        list.append(li);
      });
      $('[data-empty]', this).hidden = list.children.length > 0;
      document.addEventListener('lists:change', () => {
        $$('li', list).forEach((li) => {
          const h = $('[data-handle]', li)?.dataset.handle;
          if (h && !favs.has(h)) li.remove();
        });
        $('[data-empty]', this).hidden = list.children.length > 0;
      }, { once: true });
    }
  }
  define('favorites-list', FavoritesList);

  class RecentlyViewed extends HTMLElement {
    async connectedCallback() {
      const handles = store.get('calibre:recent', []).filter((h) => h !== this.dataset.current).slice(0, Number(this.dataset.limit || 4));
      if (!handles.length) return;
      const cards = await Promise.all(handles.map((h) => fetchCard(h).catch(() => null)));
      const list = $('[data-list]', this);
      cards.filter(Boolean).forEach((html) => {
        const li = document.createElement('li');
        li.innerHTML = html;
        list.append(li);
      });
      if (list.children.length) this.hidden = false;
    }
  }
  define('recently-viewed', RecentlyViewed);

  class CompareTable extends HTMLElement {
    connectedCallback() {
      const fromUrl = new URLSearchParams(window.location.search).get('h');
      this.shared = !!fromUrl;
      this.handles = fromUrl ? fromUrl.split(',').filter(Boolean).slice(0, 3) : compare.all().map((i) => i.handle);
      $('[data-share]', this)?.addEventListener('click', async () => {
        const url = `${window.location.origin}${T.routes.search}?view=comparer&h=${this.handles.join(',')}`;
        try { await navigator.clipboard.writeText(url); toast(S.copied); } catch { /* refusé */ }
      });
      this.render();
    }
    async render() {
      const table = $('[data-table]', this);
      const empty = $('[data-empty]', this);
      if (!this.handles.length) { empty.hidden = false; table.innerHTML = ''; return; }
      const items = (await Promise.all(this.handles.map(async (h) => {
        try {
          const res = await fetch(`${ROOT}/products/${encodeURIComponent(h)}?view=compare`);
          return res.ok ? JSON.parse(await res.text()) : null;
        } catch { return null; }
      }))).filter(Boolean);
      if (!items.length) { empty.hidden = false; table.innerHTML = ''; return; }
      empty.hidden = true;
      $('[data-share]', this).hidden = false;
      const minPrice = Math.min(...items.map((i) => i.price_cents));
      const maxJ = Math.max(...items.map((i) => parseFloat(String(i.joules).replace(',', '.')) || 0));
      const row = (label, fn) => `<tr><th scope="row">${esc(label)}</th>${items.map((i) => `<td>${fn(i)}</td>`).join('')}</tr>`;
      table.innerHTML = `<table class="cmp-table"><thead><tr><th></th>${items.map((i) => `
        <td><div class="cmp-head">
          <a href="${esc(i.url)}" class="cmp-head__img"><img src="${esc(i.image)}" alt="" loading="lazy"></a>
          <a href="${esc(i.url)}" class="cmp-head__title">${esc(i.title)}</a>
          ${this.shared ? '' : `<button type="button" class="label link-underline muted cmp-remove" data-remove="${esc(i.handle)}">×</button>`}
        </div></td>`).join('')}</tr></thead><tbody>
        ${row('Prix', (i) => `<span class="tabular${i.price_cents === minPrice && items.length > 1 ? ' is-best' : ''}">${esc(i.price)}</span>`)}
        ${row('Marque', (i) => esc(i.brand || '—'))}
        ${row('Énergie', (i) => `<span class="num tabular${(parseFloat(String(i.joules).replace(',', '.')) || 0) === maxJ && maxJ > 0 && items.length > 1 ? ' is-best' : ''}">${esc(i.joules ? `${i.joules} J` : '—')}</span>`)}
        ${row('Calibre', (i) => `<span class="num">${esc(i.calibre || '—')}</span>`)}
        ${row('Source', (i) => esc(i.source || '—'))}
        ${row('Catégorie', (i) => esc(i.category ? `Catégorie ${i.category}` : '—'))}
        ${row('Avis', (i) => (i.rating ? `★ ${esc(String(i.rating).replace('.', ','))} · ${esc(i.reviews)}` : '—'))}
        ${row('', (i) => (i.available && i.single
          ? `<button type="button" class="btn btn-primary" data-add-id="${esc(i.variant_id)}">${esc(S.addToCart)}</button>`
          : `<a href="${esc(i.url)}" class="btn btn-ghost">${i.available ? '→' : esc(S.soldOut)}</a>`))}
      </tbody></table>`;
      table.onclick = async (e) => {
        const rm = e.target.closest('[data-remove]');
        if (rm) { compare.remove(rm.dataset.remove); this.handles = this.handles.filter((h) => h !== rm.dataset.remove); this.render(); return; }
        const add = e.target.closest('[data-add-id]');
        if (add) {
          add.classList.add('is-loading');
          try { await cartRequest('add.js', { items: [{ id: Number(add.dataset.addId), quantity: 1 }] }); openCart(); } catch (err) { toast(err?.description || S.addError); }
          add.classList.remove('is-loading');
        }
      };
    }
  }
  define('compare-table', CompareTable);

  /* ───────── Quiz « Quelle défense pour moi » ───────── */
  // Réponses : type (pistol | spray | contact), budget (s | m | l), style (compact | power | simple).
  // Aucun conseil d'usage : on oriente seulement vers des familles de produits en stock.
  class GuideQuiz extends HTMLElement {
    connectedCallback() {
      try { this.items = JSON.parse($('[data-quiz-products]', this).textContent); } catch { this.items = []; }
      try { this.str = decodeAll(JSON.parse($('[data-quiz-strings]', this).textContent)); } catch { this.str = {}; }
      this.low = Number(this.dataset.low || 10000);
      this.high = Number(this.dataset.high || 20000);
      this.steps = $$('[data-step]', this);
      this.answers = {};
      this.step = 0;
      $$('.quiz__opt', this).forEach((b) => b.addEventListener('click', () => {
        this.answers[b.dataset.key] = b.dataset.value;
        this.show(this.step + 1);
      }));
      $('[data-back]', this).addEventListener('click', () => this.show(this.step - 1));
      $('[data-restart]', this).addEventListener('click', () => { this.answers = {}; this.show(0); });
      this.show(0);
    }
    show(n) {
      this.step = Math.max(0, n);
      const done = this.step >= this.steps.length;
      this.steps.forEach((s, i) => { s.hidden = i !== this.step; });
      $('[data-result]', this).hidden = !done;
      $('[data-back]', this).hidden = this.step === 0;
      $$('[data-bar]', this).forEach((b, i) => { b.style.transform = `scaleX(${i < this.step ? 1 : 0})`; });
      $$('.quiz__opt', this).forEach((b) => b.classList.toggle('is-selected', this.answers[b.dataset.key] === b.dataset.value));
      if (done) this.results();
      if (n > 0) this.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    }
    kind(p) {
      const src = String(p.src || '');
      if (/pistolet|calibre|revolver/.test(src)) return 'pistol';
      if (/aerosol|lacrym/.test(src)) return 'spray';
      if (/shocker|baton|matraque/.test(src)) return 'contact';
      const t = `${p.title} ${(p.tags || []).join(' ')}`.toLowerCase();
      if (/a[ée]rosol|lacrym|gel |spray|gaz poivre/.test(t)) return 'spray';
      if (/shocker|matraque|b[aâ]ton/.test(t)) return 'contact';
      if (/pistolet|revolver|sentinel|guardian|pdw|t4e|hdp|tp50|tr50|tr68/.test(t)) return 'pistol';
      return 'other';
    }
    score(p) {
      const a = this.answers;
      const s = this.str;
      const t = String(p.title).toLowerCase();
      const j = Number(p.joules) || Number((String(p.title).match(/(\d+(?:[.,]\d+)?)\s?j\b/i) || [])[1]?.replace(',', '.')) || 0;
      const kind = this.kind(p);
      let n = 0;
      const r = [];
      if (kind === a.type) n += 6; else n -= 6;
      const price = p.price;
      const inBudget = a.budget === 's' ? price < this.low : a.budget === 'm' ? price >= this.low * 0.8 && price <= this.high * 1.05 : price > this.high * 0.95;
      if (inBudget) { n += 3; r.push(s.budget); } else n -= 2;
      if (a.style === 'compact' && /compact|pdw|mini|25 ?ml|50 ?ml|porte-cl/.test(t)) { n += 3; r.push(s.compact); }
      if (a.style === 'power' && (j >= 17 || /100 ?ml|guardian/.test(t))) { n += 3; r.push(s.power); }
      if (a.style === 'simple' && /pack|pr[eê]t [aà] tirer/.test(t)) { n += 3; r.push(s.pack); }
      if (a.style === 'simple' && kind === 'spray') { n += 2; r.push(s.spray); }
      if (a.style === 'simple' && kind !== 'spray' && !/pack/.test(t)) r.push(s.simple);
      return { n, r: r.filter(Boolean).slice(0, 3) };
    }
    results() {
      const picks = this.items
        .map((p, i) => ({ p, i, ...this.score(p) }))
        .filter((x) => x.n > 0 && !/c[âa]ble|chargeur|pi[èe]ces? d[ée]tach|batterie|recharge seule/i.test(x.p.title))
        .sort((x, y) => y.n - x.n || x.i - y.i)
        .slice(0, 3);
      $('[data-picks]', this).innerHTML = picks.map(({ p, r }, i) => `
        <li class="fade-up" style="--d: ${200 + i * 110}ms">
          <a href="${esc(p.url)}" class="pick">
            ${i === 0 ? `<span class="pick__best label">${esc(this.str.best)}</span>` : ''}
            <span class="pick__img">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''}</span>
            <span class="pick__body">
              <span class="label muted">${esc(p.brand || '')}${p.joules ? ` · ${esc(formatJ(p.joules))}` : ''}${p.category ? ` · Cat. ${esc(p.category)}` : ''}</span>
              <span class="pick__title">${esc(p.title)}</span>
              <ul class="pick__reasons">${r.map((x) => `<li><span class="dot" aria-hidden="true"></span>${esc(x)}</li>`).join('')}</ul>
              <span class="pick__price tabular">${esc(formatMoney(p.price))}</span>
            </span>
          </a>
        </li>`).join('') || `<li class="empty empty--left"><p>${esc(this.str.none || '')}</p></li>`;
    }
  }
  define('guide-quiz', GuideQuiz);

  /* ───────── Compteurs ───────── */
  class CountUp extends HTMLElement {
    connectedCallback() {
      const to = Number(String(this.dataset.to || '').replace(/[^\d.]/g, ''));
      if (!to || reduced || T.settings.designMode || !('IntersectionObserver' in window)) return;
      this.textContent = '0';
      const io = new IntersectionObserver(([en]) => {
        if (!en.isIntersecting) return;
        io.disconnect();
        const start = performance.now();
        const tick = (t) => {
          const p = Math.min(1, (t - start) / 1600);
          this.textContent = Math.round(to * (1 - Math.pow(1 - p, 4))).toLocaleString('fr-FR');
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
      io.observe(this);
    }
  }
  define('count-up', CountUp);

  /* ───────── Collections : filtres, tri, « afficher plus » ───────── */
  function navigateWithForm(form) {
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(form).entries()) {
      if (String(v).trim() !== '') params.append(k, v);
    }
    window.location.href = `${form.getAttribute('action')}?${params.toString()}`;
  }
  document.addEventListener('change', (e) => {
    const form = e.target.closest?.('[data-facet-form]');
    if (form) {
      if (e.target.type === 'number') return;
      navigateWithForm(form);
      return;
    }
    if (e.target.matches?.('[data-sort]')) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });
  document.addEventListener('focusout', debounce((e) => {
    if (e.target.type === 'number' && e.target.closest('[data-facet-form]')) navigateWithForm(e.target.closest('[data-facet-form]'));
  }, 300));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.type === 'number' && e.target.closest?.('[data-facet-form]')) {
      e.preventDefault();
      navigateWithForm(e.target.closest('[data-facet-form]'));
    }
  });

  class LoadMore extends HTMLElement {
    connectedCallback() {
      $('[data-more]', this)?.addEventListener('click', (e) => { e.preventDefault(); this.load(); });
    }
    async load() {
      const btn = $('[data-more]', this);
      btn.classList.add('is-loading');
      const url = new URL(this.dataset.next, window.location.origin);
      url.searchParams.set('section_id', this.dataset.section);
      try {
        const doc = parse(await (await fetch(url)).text());
        const grid = this.parentElement.querySelector('[data-grid]');
        const fresh = $('[data-grid]', doc);
        if (grid && fresh) {
          Array.from(fresh.children).forEach((li) => grid.append(li));
        }
        const next = $('load-more', doc);
        if (next) {
          this.dataset.next = next.dataset.next;
          $('[data-shown]', this).textContent = $('[data-shown]', next).textContent;
          $('[data-fill]', this).style.width = $('[data-fill]', next).style.width;
          btn.href = next.dataset.next;
        } else {
          this.remove();
        }
      } catch {
        window.location.href = this.dataset.next;
      } finally {
        btn.classList.remove('is-loading');
      }
    }
  }
  define('load-more', LoadMore);

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('.card') || !this.dataset.url) return;
      const io = new IntersectionObserver(async ([en]) => {
        if (!en.isIntersecting) return;
        io.disconnect();
        try {
          const doc = parse(await (await fetch(this.dataset.url)).text());
          const fresh = $('product-recommendations', doc);
          if (fresh && fresh.innerHTML.trim()) {
            // Même calibre ou sans calibre (CO2, lampes…) : jamais de .68 proposé sur une arme .50, et inversement.
            const cal = this.dataset.cal || '';
            const max = Number(this.dataset.limit) || 4;
            let kept = 0;
            $$('.grid-products > li', fresh).forEach((li) => {
              const c = $('.card', li)?.dataset.cal || '';
              if ((cal && c && c !== cal) || kept >= max) li.remove();
              else kept += 1;
            });
            if (!kept) return;
            this.innerHTML = fresh.innerHTML;
            initReveal(this);
          }
        } catch { /* pas de recommandations */ }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  define('product-recommendations', ProductRecommendations);

  /* ───────── Vérification de l'âge (+ choix des cookies) ───────── */
  function setConsent(accepted) {
    const apply = () => {
      try {
        window.Shopify?.customerPrivacy?.setTrackingConsent(
          { analytics: accepted, marketing: accepted, preferences: accepted, sale_of_data: accepted },
          () => {},
        );
      } catch { /* API indisponible */ }
    };
    if (window.Shopify?.customerPrivacy) { apply(); return; }
    try { window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) apply(); }); } catch { /* rien */ }
  }
  class AgeGate extends HTMLElement {
    connectedCallback() {
      const d = $('dialog', this);
      if (!d || store.get('calibre:age-ok', false) === true) return;
      d.setAttribute('data-locked', '');
      d.addEventListener('cancel', (e) => e.preventDefault());
      $('[data-yes]', this)?.addEventListener('click', () => {
        store.set('calibre:age-ok', true);
        if (this.dataset.cookies === 'true') setConsent($('input[name="age-cookies"]:checked', this)?.value === 'yes');
        d.close();
      });
      $('[data-no]', this)?.addEventListener('click', () => {
        $$('[data-ask]', this).forEach((el) => { el.hidden = true; });
        $$('[data-minor]', this).forEach((el) => { el.hidden = false; });
      });
      d.showModal();
    }
  }
  define('age-gate', AgeGate);

  /* ───────── Pop-up newsletter ───────── */
  // Après la vérification d'âge et le délai réglé, puis plus pendant N jours. Rouvert d'office après l'envoi du formulaire (#NewsletterPopup).
  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = $('dialog', this);
      if (!this.dialog) return;
      $$('[data-close]', this).forEach((b) => b.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => store.set('calibre:nl-popup', Date.now()));
      const copy = $('[data-nlp-copy]', this);
      copy?.addEventListener('click', () => {
        navigator.clipboard?.writeText($('[data-nlp-code]', this).textContent.trim()).then(() => { copy.textContent = copy.dataset.done; }).catch(() => {});
      });
      if (window.location.hash === '#NewsletterPopup') { this.open(); return; }
      if (T.settings.designMode) return;
      const last = Number(store.get('calibre:nl-popup', 0)) || 0;
      if (Date.now() - last < (Number(this.dataset.days) || 30) * 864e5) return;
      setTimeout(() => this.whenFree(), (Number(this.dataset.delay) || 15) * 1000);
    }

    // N'interrompt ni la vérification d'âge, ni le panier, ni la recherche : réessaie plus tard
    whenFree() {
      if (document.querySelector('dialog[open]')) { setTimeout(() => this.whenFree(), 8000); return; }
      this.open();
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      if (window.location.hash === '#NewsletterPopup') history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }
  define('newsletter-popup', NewsletterPopup);

  /* ───────── Confirmation de majorité au panier ───────── */
  // La case est enregistrée en attribut de panier dès qu'on la coche (survit au re-rendu du tiroir).
  document.addEventListener('change', (e) => {
    const box = e.target.closest?.('[data-age-confirm]');
    if (!box) return;
    box.closest('.age-check')?.classList.remove('is-error');
    fetch(`${ROOT}/cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [box.name.replace(/^attributes\[|\]$/g, '')]: box.checked ? 'Oui' : '' } }),
    });
  });
  document.addEventListener('invalid', (e) => {
    const box = e.target.closest?.('[data-age-confirm]');
    if (!box) return;
    box.closest('.age-check')?.classList.add('is-error');
    toast(S.ageConfirmRequired);
  }, true);

  /* ───────── Articles : sommaire automatique ───────── */
  function initToc() {
    const body = $('[data-article-body]');
    const list = $('[data-toc]');
    if (!body || !list) return;
    const heads = $$('h2', body);
    const slug = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 60);
    list.innerHTML = heads.map((h, i) => {
      if (!h.id) h.id = slug(h.textContent) || `s${i}`;
      return `<li><a href="#${h.id}">${esc(h.textContent.trim())}</a></li>`;
    }).join('');
    if (!('IntersectionObserver' in window)) return;
    const links = $$('a', list);
    const io = new IntersectionObserver((entries) => {
      for (const en of entries) {
        if (en.isIntersecting) links.forEach((a) => a.setAttribute('aria-current', String(a.hash === `#${en.target.id}`)));
      }
    }, { rootMargin: '0px 0px -70% 0px' });
    heads.forEach((h) => io.observe(h));
  }

  /* ───────── Démarrage ───────── */
  function init() {
    initReveal();
    syncFavDot();
    initToc();
    if (window.location.hash === '#recover') {
      $('[data-auth-login]')?.setAttribute('hidden', '');
      $('[data-auth-recover]')?.removeAttribute('hidden');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', (e) => initReveal(e.target));
})();
